import _ from "app/lang";

import { DrawerMenuItem } from "../DrawerMenu";

/**
 * ECCLOUD-10562: menu for Praxis edge-AI devices (product_type edge_device).
 *
 * Deliberately short. A Praxis unit is not an access point — no radios, SSIDs or
 * wireless clients — so the wireless and client entries the AP menus carry would
 * all lead to empty pages. What it reports is system load and AI accelerator
 * utilisation, both on the dashboard.
 *
 * Statistics carries System (memory, CPU and accelerator series) and, for
 * Praxis, an Addons page: per-addon statistics such as the GaugeVision
 * per-camera gauge readings (ECCLOUD-12063). There is no Wireless or Networks
 * entry because the unit reports neither.
 *
 * Without this factory getMenuItems() throws "No device menu factory for product
 * type edge_device" and the whole drawer fails to render.
 */
export default function (baseUrl: string): DrawerMenuItem[] {
    return [
        {
            icon: "dashboard",
            text: _("Dashboard"),
            href: `${baseUrl}/dashboard`
        },
        {
            icon: "multiline_chart",
            text: _("Statistics"),
            subitems: [
                {
                    icon: "pie_chart",
                    text: _("System"),
                    href: `${baseUrl}/system`
                },
                {
                    icon: "pie_chart",
                    text: _("Addons"),
                    href: `${baseUrl}/addons`
                }
            ]
        },
        {
            icon: "list_alt",
            text: _("Activity"),
            href: `${baseUrl}/activity`
        }
    ];
}
